export default class Section {
    static fromData(data) {
        if (!data) {
            return;
        }

        const section = new Section();
        section.id = data.id;
        section.name = data.name;

        Object.seal(section);
        return section;
    }
}
